"use strict";const t=require("react"),o=require("./useDocumentKeydown.js"),r=e=>{const s=t.useCallback(n=>{n.key==="Escape"&&e&&e()},[e]);o(e&&s)};module.exports=r;
//# sourceMappingURL=useEscapeKeyHandler.js.map
